<template>
  <div class='editor'>
    <div class="editorContainer">
      <iframe name="editorIframe" class="editorIframe" ref="editorIframe"
              :src='editorURL' frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex'
  //axios
  import axios from 'axios'
  import apiConfig from 'common/js/api_config'
  //通信总线
  import Bus from 'common/js/bus.js'

  export default {
    name: "editor",
    data() {
      return {
        editorInstance: null,
        isCrossDomain: false,
        editorURL: null
      }
    },
    props: [],
    computed: {},
    watch: {},
    methods: {
      initEditorURL() {
        //初始化编辑器URL
        let url = apiConfig.debug ? "http://192.168.1.247/shall/ueditor/editor.html" : "/shall/ueditor/editor.html"
        this.editorURL = url
      },
      initEditor() {
        try {
          this.editorInstance = this.$refs.editorIframe.contentWindow.UE.getEditor('editor');
        } catch (e) {
          this.isCrossDomain = true
          console.log('初始化编辑器异常：')
          console.log(e)
        }
      },
      //读取编辑器内容
      getEditorContent() {
        if (this.isCrossDomain) {
          this.$notify({
            group: "global",
            title: "温馨提示",
            text: "读内容异常！"
          })
          return false
        }
        return this.editorInstance.getContent();
      },
      //重置编辑器内容
      setEditorContent(content) {
        if (this.isCrossDomain) {
          this.$notify({
            group: "global",
            title: "温馨提示",
            text: "写内容异常！"
          })
          return false
        }
        if (!this.editorInstance) {
          setTimeout(() => {
            this.setEditorContent(content)
          }, 500)
          return
        }
        this.editorInstance.setContent(content);
      },
      //获取编辑器内容是否为空
      getEditorEmptyState() {
        if (!this.isCrossDomain) {
          this.$notify({
            group: "global",
            title: "温馨提示",
            text: "获取状态异常！"
          })
          return false
        }
      }

    },
    filters: {},
    components: {},
    activated() {
    },
    mounted() {
      this.initEditorURL()
      this.$refs.editorIframe.addEventListener('load', () => {
        this.$nextTick(() => {
          this.initEditor()
        })
      })

    }
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .editor
    .editorContainer
      .editorIframe
        height 400px
        width 100%
</style>



// WEBPACK FOOTER //
// src/components/globalComp/editor.vue